import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const sessionId = decodeURIComponent(match[1]);
    api.post("/auth/session", { session_id: sessionId })
      .then(async (r) => {
        // Use Emergent's session_token from the original session-data response,
        // which the backend returned to us via the user payload (we also stored
        // it in DB). Frontend needs to fetch it; we proxy via the response.
        // Backend currently doesn't return session_token in body — fetch via /me using token from a hidden header is impossible.
        // Instead, the backend response sets a cookie AND returns user data; we
        // need the token in localStorage for cross-origin Bearer auth.
        // Solution: backend now returns the token in the JSON.
        setToken(r.data.session_token);
        setUser(r.data);
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-ink grid place-items-center text-white">
      <div className="text-mono text-xs uppercase tracking-[0.4em] text-zinc-500">Authenticating…</div>
    </div>
  );
}
